<template>
    <div class="flex flex-col dark:bg-slate-800">
        <section class="text-gray-600 body-font dark:bg-slate-800">
        <div class="container px-5 py-24 mx-auto flex flex-wrap items-center dark:bg-slate-800">
            <div class="lg:w-3/5 md:w-1/2 md:pr-16 lg:pr-0 pr-0">
            <h1 class="title-font font-medium text-3xl text-gray-900  dark:text-gray-200">The Best Way to get in on the action is to simply create an account</h1>
            <p class="leading-relaxed mt-4 dark:text-gray-300">To spit some real fax, we're gonna need to identify you with a unique username, keep it short and rememberable</p>
            </div>
            <div class="lg:w-2/6 md:w-1/2 bg-gray-100 dark:bg-opacity-10 rounded-lg p-8 flex flex-col md:ml-auto w-full mt-10 md:mt-0">
            <h2 class="text-gray-900 dark:text-gray-200 text-lg font-medium title-font mb-5">Sign Up</h2>
            <div class="relative mb-6 flex flex-col">
                <label for="username" class="leading-7 text-sm text-gray-600 self-start ml-1 dark:text-gray-200">Username</label>
                <input type="text" id="full-name" name="username" v-model="username" placeholder="Username" class="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:ring-2 focus:bg-transparent focus:ring-green-200 focus:border-green-500 text-base outline-none text-gray-700 dark:focus:bg-opacity-10 dark:focus:bg-white dark:bg-opacity-0 dark:text-gray-100 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out mt-3">
            </div>
            <div class="relative mb-6 flex flex-col">
                <label for="email" class="leading-7 text-sm text-gray-600 self-start ml-1 dark:text-gray-200">Email</label>
                <input type="email" id="email" v-model="email" placeholder="E-Mail" name="email" class="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:ring-2 focus:bg-transparent focus:ring-green-200 focus:border-green-500 text-base outline-none text-gray-700 dark:focus:bg-opacity-10 dark:focus:bg-white dark:bg-opacity-0 dark:text-gray-100 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out mt-3">
            </div>
            <div class="relative mb-6 flex flex-col">
                <label for="password" class="leading-7 text-sm text-gray-600 self-start ml-1  dark:text-gray-200">Password</label>
                <input type="password" id="password" name="password" v-model="password" placeholder="Password" class="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:ring-2 focus:bg-transparent focus:ring-green-200 focus:border-green-500 text-base outline-none text-gray-700 dark:focus:bg-opacity-10 dark:focus:bg-white dark:bg-opacity-0 dark:text-gray-100 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out mt-3">
            </div>
            <button @click="createAccount" class="text-white bg-green-500 border-0 py-2 px-8 focus:outline-none hover:bg-green-600 rounded text-lg">Create Account</button>
            <!--<button @click="snacc('Salud!')" class="text-white bg-green-500 border-0 py-2 px-8 focus:outline-none hover:bg-green-600 rounded text-lg">Snacc Yourself</button>-->
            <p class="text-xs text-gray-500 mt-3 dark:text-gray-400">Keep your head strong and your password stronger</p>
            </div>
        </div>
        </section>

        <div class="border border-solid border-green-500 text-xl font-medium rounded-lg bg-white opacity-0 transition-all w-11/12 bottom-3 fixed self-center pt-2 hidden pb-2  dark:bg-opacity-75 dark:text-gray-600" ref="snackbar">
            {{ navMessage }}
        </div>
    </div>
</template>

<script>
const devServer = process.env.VUE_APP_PROD_SERVER || "http://localhost:3030" ;
export default {
    name: "CreateAcc",
    props: {
        auth: Boolean
    },
    data() {
        return {
            navMessage: "",
        }
    },
    methods: {


        snacc: async function(message) {
            this.navMessage = message;
            //console.log("making the opacity to 1....");
            this.$refs.snackbar.style.display = "block";
            this.$refs.snackbar.style.opacity = 1;
            await setTimeout(() => {
                this.$refs.snackbar.style.opacity = 0;
            }, 3000);
            await setTimeout(() => {
                this.$refs.snackbar.style.display = "none";
            }, 3500);
            //console.log("turned the opacity to 0 again....");
        },


        createAccount: async function() {
            const bodyData = {
                username: this.username,
                email: this.email,
                password: this.password
            }
            if(!(this.username && this.email && this.password)) {
                this.snacc("All Fields are required");
                return;
            }
            const respomse = await fetch(`${devServer}/api/auth/create/`, {
                method: "POST",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(bodyData)
            })
            if(respomse.status == 201) {
                this.snacc("Account Created Successfully!"); //+ JSON.stringify(await respomse.json()));
            } else {
                const resj = await respomse.json();
                if(resj['fail']) {
                    this.snacc(resj['fail']);
                } else {
                    // some weirder error
                    this.snacc("Account creation error");// + JSON.stringify(await respomse.json()));
                }

            }
        }
    }
}
</script>
